const frameCheck = () => {
    const unpairLocationElement = document.querySelector("#unpair-location");
    if (!unpairLocationElement) return;
    if (window.location !== window.parent.location) {
        unpairLocationElement.value = "lms_frame";
    } else {
        unpairLocationElement.value = "standalone";
    }
}

const pollForCourse = () => {
    const noCourseElement = document.getElementById("manage-sync-options__no_course");
    if (!noCourseElement) return;

    const pollingInterval = setInterval(function() {
        $.getJSON('/check_course_updates', function(data) {
            if (data.lms_course_exists) {
                clearInterval(pollingInterval);
                $('#manage-sync-options__course_status').load('/check_course_updates', function() {
                    Rails.fire(document, 'turbolinks:load');
                    // Remove any alerts that may be there
                    $('.alert').remove();
                });
            } else if (data.new_courses) {
                clearInterval(pollingInterval);
                $('#manage-sync-options__course_selection').load('/check_course_updates', function() {
                    Rails.fire(document, 'turbolinks:load');
                });
            }
        });
    }, 5000);

    document.addEventListener("turbolinks:before-visit", function() {
        clearInterval(pollingInterval);
    });
}

document.addEventListener('turbolinks:load', function() {
    frameCheck();
    pollForCourse();
});
